// Paylaşılan Button bileşeni — variant + size sistemi
// Kullanım:
//   <Button>Kaydet</Button>                              // primary, md
//   <Button variant="ghost" size="sm">İptal</Button>
//   <Button variant="danger" icon={<TrashIcon/>}>Sil</Button>
//   <Button iconOnly icon={<EditIcon/>} title="Düzenle"/>
import React from 'react';
import { useTranslation } from 'react-i18next';
import { fieldLabel } from '../../i18n/fieldMap';

export default function Button({
  variant = 'primary',   // 'primary' | 'ghost' | 'danger' | 'success'
  size = 'md',           // 'sm' | 'md' | 'lg'
  icon = null,
  iconOnly = false,
  loading = false,
  disabled = false,
  type = 'button',
  className = '',
  children,
  ...rest
}) {
  const { i18n } = useTranslation();
  // Tek string text içerikleri için auto-translate; JSX children aynen.
  const renderChildren = typeof children === 'string' ? fieldLabel(children, i18n.language) : children;
  const cls = [
    'ui-btn',
    `ui-btn-${variant}`,
    `ui-btn-${size}`,
    iconOnly ? 'ui-btn-icon-only' : '',
    loading ? 'ui-btn-loading' : '',
    className,
  ].filter(Boolean).join(' ');
  return (
    <button type={type} className={cls} disabled={disabled || loading} {...rest}>
      {loading && <span className="ui-spinner" aria-hidden="true" />}
      {!loading && icon && <span className="ui-btn-ico">{icon}</span>}
      {!iconOnly && children && <span>{renderChildren}</span>}
    </button>
  );
}
